namespace InvData {
    export class SystemPropertyDefinitionIds {
        public static readonly Name = 1;
        public static readonly InceptionDate = 2;
        public static readonly TrackingPerformance = 3;
        public static readonly TrackingMarketValue = 4;
        public static readonly FeaturedItem = 5;
        public static readonly CurrentlyInvested = 6;
        public static readonly Description = 7;
        
        public static readonly Comment = 9;
        public static readonly SpecialEntityType = 10;
        
        public static readonly Author = 14;
        
        public static readonly DocumentLinks = 18;
        
        public static readonly ManagementCompany = 19;
        
        public static readonly LegalName = 25;
        
        public static readonly Benchmark = 45;
        public static readonly SecondaryBenchmark = 51;
        
        public static readonly AssetState = 46;
        
        public static readonly AccountNumber = 52;
        
        public static readonly PerformanceProxy = 100;
        
        public static readonly MonthlyPerformanceEstimationMethod = 103;
        public static readonly EntityValueEstimationMethod = 104;
        public static readonly InvestmentValueEstimationMethod = 105;
        public static readonly TwrCalculationEndDate = 106;
        public static readonly IrrCalculationEndDate = 107;
        public static readonly TwrCalculationStartDate = 108;
    }

    export namespace SystemPropertyDefinitionIds {
        export class DataImport {
            public static readonly ImportCode = 8;
            public static readonly ImportTrail = 11;
            
            public static readonly SolovisAssetCode = 47;
            public static readonly Figi = 50;
        }

        export class Contact {
            public static readonly Phone = 15;
            public static readonly Website = 16;
            public static readonly Address = 17;
            public static readonly Email = 31;
        }

        export class Tx {
            public static readonly DefaultTxCashAccount = 42;
            public static readonly DefaultTxLiabilities = 43;
            public static readonly DefaultTxReceivables = 44;
            public static readonly TxnNoticeLink = 53;
        }

        export class Related {
            public static readonly Entity = 20;
            public static readonly Investment = 21;
            public static readonly Contact = 22;
            public static readonly Note = 23;
            public static readonly Transaction = 24;
        }

        export class PrivateEquity {
            public static readonly InvestmentPeriodEnd = 150;
            public static readonly FundTermEnd = 151;
            public static readonly Commitment = 152;
            public static readonly Vintage = 153;
        }

        export class Liability {
            public static readonly MonthlyPercentage = 27;
            public static readonly MonthlyAmount = 28;
            public static readonly MonthlyPriority = 29;
        }

        export class Receivable {
            public static readonly MonthlyAmount = 30;
        }

        export class Derivatives {
            public static readonly Underlying = 32;
            public static readonly Delta = 33;
            public static readonly Theta = 34;
            public static readonly NotionalValue = 35;
            public static readonly DeltaAdjustedNotionalValue = 36;
            public static readonly ExpirationDate = 37;
            public static readonly TotalProfitLoss = 38;
            public static readonly OneDayProfitLoss = 39;
            
            public static readonly StrikePrice = 48;
            public static readonly Counterparty = 49;
        }

        export class Values {
            public static readonly AverageCostBasisPerUnit = 40;
            
            /**
             * StatementLinks are URL links to statements that provide market values or performance for entities or investments as of a given date.
             */
            public static readonly StatementLinks = 41;
            
            public static readonly PerfEstimateLink = 54;
            
            public static readonly MarketValueComment = 55;
        }

        export class Managers {
            public static readonly ManagerType = 56;

            public static readonly IardCrdNumber = 57;

            public static readonly Manager = 58;

            public static readonly ParentManager = 60;

            public static readonly CoSponsor = 61;
        }
    }
}